import { render, staticRenderFns } from "./isr-porla-prestacion-deun-servicio-personal-subordinado.vue?vue&type=template&id=c1b34020&lang=html&"
import script from "./isr-porla-prestacion-deun-servicio-personal-subordinado.vue?vue&type=script&lang=js&"
export * from "./isr-porla-prestacion-deun-servicio-personal-subordinado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports